var $158d0aece262406d$exports = {};
$158d0aece262406d$exports = {
    "loading": `Caricamento...`,
    "loadingMore": `Caricamento altri...`
};


export {$158d0aece262406d$exports as default};
//# sourceMappingURL=it-IT.module.js.map
